import { render, staticRenderFns } from "./ViewSPRPage.vue?vue&type=template&id=5b18feae&scoped=true&"
import script from "./ViewSPRPage.vue?vue&type=script&lang=js&"
export * from "./ViewSPRPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewSPRPage.vue?vue&type=style&index=0&id=5b18feae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b18feae",
  null
  
)

export default component.exports